import { Components } from '@mui/material'

export function OverridedRadio(): Components {
  return {
    MuiRadio: {
      styleOverrides: {
        root: {
          padding: '0 9px',
        },
      },
    },
  }
}
